var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00076 1.39673C9.76251 -0.185015 12.485 -0.132515 14.1823 1.56773C15.8788 3.26873 15.9373 5.97773 14.3593 7.74473L7.99925 14.1137L1.64075 7.74473C0.0627545 5.97773 0.122005 3.26423 1.81775 1.56773C3.51651 -0.130265 6.23376 -0.187265 8.00076 1.39673ZM13.1203 2.62748C11.9953 1.50098 10.1803 1.45524 9.00276 2.51273L8.0015 3.41123L6.99951 2.51348C5.81825 1.45449 4.007 1.50098 2.879 2.62898C1.7615 3.74648 1.70525 5.53523 2.735 6.71723L8 11.9905L13.265 6.71798C14.2955 5.53523 14.2393 3.74873 13.1203 2.62748Z",
    fill: "#555A69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.5e28ffee.svg";
export { ForwardRef as ReactComponent };